query Brands {
    brands {
        id

        name

        legacyAlias
        legacyID
    }
}
